import ButtonDefault from "../../../ui/Button";
import * as Css from "./style";
import { ContentCreateProps } from "./contentCreateType";
import { useContentCreate } from "./useContentCreate";
import BulkResultsTable from "../../bulkResultTable";
import { DotLoader } from "react-spinners";
import { Table } from "@zendeskgarden/react-tables";
import StatusTag from "../../../ui/StatusTag";

export default function ContentCreate({ type, headers, rows, result, setResult, loading, setLoading }: ContentCreateProps) {
    const { hasData, handleCreate, handleReset, isStatus, commentType, setCommentType, countErrors } = useContentCreate({ type, headers, rows, result, setResult, loading, setLoading });
    
    const errorInfo = result ? countErrors(result, type || "ticket") : null;
    const hasErrors = errorInfo && errorInfo.count > 0;

    return (
        <Css.ContainerContent>
            <Css.ContainerTitle>
                <Css.ContainerType>
                    <p>
                        {type === "user"
                            ? "Usuários"
                            : type === "ticket"
                                ? "Tickets"
                                : "Organizações"}
                    </p>
                    {hasData && <span>{rows.length}</span>}
                </Css.ContainerType>
                
                {type === "ticket" && hasData && !loading && !result &&  (
                    <Css.CommentTypeSelector>
                        <label>Tipo do comentário:</label>
                        <Css.CommentTypeToggle 
                            $active={commentType === "public"}
                            onClick={() => setCommentType("public")}
                        >
                            <span>Público</span>
                        </Css.CommentTypeToggle>
                        <Css.CommentTypeToggle 
                            $active={commentType === "internal"}
                            onClick={() => setCommentType("internal")}
                        >
                            <span>Interno</span>
                        </Css.CommentTypeToggle>
                    </Css.CommentTypeSelector>
                )}

                <div>
                    <ButtonDefault
                        title={
                            result
                                ? "Voltar"
                                : loading
                                    ? (type === "organization" ? "Criando organizações..." : type === "user" ? "Criando usuários..." : "Criando tickets...")
                                    : (type === "organization" ? "Criar organizações" : type === "user" ? "Criar usuários" : "Criar tickets")
                        }
                        onClick={result ? handleReset : handleCreate}
                        disabled={loading || rows.length === 0}
                        color="#2F5BFF"
                        textColor="white"
                    />
                </div>
            </Css.ContainerTitle>
            <Css.ContainerTable className={!hasData || loading ? "noContent" : ""}>
                {loading && (
                    <DotLoader
                        color="#87929D"
                        loading={loading}
                        size={30}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />
                )}

                {!loading && result && hasData ? (
                    <>
                        {hasErrors && (
                            <Css.ErrorBannerLarge>
                                <Css.ErrorBannerContent>
                                    <StatusTag status="error" />
                                    <Css.ErrorBannerText>
                                        <Css.ErrorBannerTitle>
                                            {errorInfo.count} {errorInfo.count === 1 ? "erro encontrado" : "erros encontrados"} na criação
                                        </Css.ErrorBannerTitle>
                                        <Css.ErrorBannerSubtitle>
                                            Veja os detalhes na tabela abaixo
                                        </Css.ErrorBannerSubtitle>
                                    </Css.ErrorBannerText>
                                </Css.ErrorBannerContent>
                            </Css.ErrorBannerLarge>
                        )}
                        <BulkResultsTable results={result} type={type as any} />
                    </>
                )
                    :
                    !hasData ? (
                        <p>Envie uma planilha para visualizar os registros que serão criados.</p>
                    ) : !loading && (
                        <Css.TableScrollWrapper>

                            <Table >
                                <Table.Head>
                                    <Table.HeaderRow>
                                        {headers.map((header, i) => (
                                            <Table.HeaderCell key={i}>
                                                {header}
                                            </Table.HeaderCell>
                                        ))}
                                    </Table.HeaderRow>
                                </Table.Head>

                                <Table.Body>
                                    {rows.map((row, ri) => (
                                        <Table.Row key={ri}>
                                            {headers.map((_, ci) => {
                                                const cell = row[ci];

                                                return (
                                                    <Table.Cell key={ci}>
                                                        {headers[ci] === "status" && isStatus(cell) ? (
                                                            <StatusTag status={cell} />
                                                        ) : cell !== null && cell !== undefined && String(cell).trim() !== "" ? (
                                                            cell
                                                        ) : (
                                                            "-"
                                                        )}
                                                    </Table.Cell>

                                                );
                                            })}
                                        </Table.Row>
                                    ))}
                                </Table.Body>
                            </Table>
                        </Css.TableScrollWrapper>
                    )

                }
            </Css.ContainerTable>
        </Css.ContainerContent>
    )
}